import { useCallback, useMemo, useState } from 'react';
import getMarks from '../../api/cars/getMarks';
import createMark from '../../api/cars/createMark';
import Select from '../Select/Select';
import DictionaryNameModal from '../Modal/DictionaryNameModal';
import useDictionaryCreator from './useDictionaryCreator';

/**
 * @param {boolean} used â Ð±/Ñ-Ð¿ÑÐ¾ÑÐµÑÑ: Ð¿Ð¾ÐºÐ°Ð·ÑÐ²Ð°ÐµÐ¼ Ð¾Ð±ÑÑÐ½ÑÐµ Ð¼Ð°ÑÐºÐ¸ Ð¿Ð»ÑÑ Ð·Ð°Ð²ÐµÐ´ÑÐ½Ð½ÑÐµ
 * Ð¿Ð¾Ð´ Ð±/Ñ Ð¸ ÑÐ°Ð·ÑÐµÑÐ°ÐµÐ¼ Ð·Ð°Ð²ÐµÑÑÐ¸ Ð½Ð¾Ð²ÑÑ Ð¿ÑÑÐ¼Ð¾ Ð·Ð´ÐµÑÑ.
 */
const SelectMarks = ({ handleSetSelect, handleSetState, style, byUser, used, ...props }) => {
  const [data, setData] = useState([]);
  const onFocus = useCallback(() => {
    getMarks({ byUser: byUser || undefined, used: used || undefined }).then((res) => {
      const marks = res.data.marks.map((item) => {
        return { value: item.id, label: item.name };
      });
      setData(marks);
    });
  }, [byUser, used]);

  const create = useCallback(async (name) => {
    // ÐÑÐº ÑÑÐ°Ð½Ð¸Ñ Ð¼Ð°ÑÐºÐ¸ Ð² Ð²ÐµÑÑÐ½ÐµÐ¼ ÑÐµÐ³Ð¸ÑÑÑÐµ â Ð¿Ð¾Ð´Ð¿Ð¸ÑÑÐ²Ð°ÐµÐ¼ Ð¾Ð¿ÑÐ¸Ñ ÑÐ°Ðº Ð¶Ðµ, Ð¸Ð½Ð°ÑÐµ
    // Ð¿Ð¾ÑÐ»Ðµ Ð¿ÐµÑÐµÐ·Ð°Ð³ÑÑÐ·ÐºÐ¸ ÑÐ¿Ð¸ÑÐºÐ° Ð²ÑÐ±ÑÐ°Ð½Ð½Ð¾Ðµ Ð·Ð½Ð°ÑÐµÐ½Ð¸Ðµ Ð²ÑÐ³Ð»ÑÐ´Ð¸Ñ Ð¸Ð½Ð°ÑÐµ.
    const label = name.toUpperCase();
    const res = await createMark({ name, used: true });
    const id = Number(res?.data?.markId);
    if (!id) throw new Error('ÐÐµ ÑÐ´Ð°Ð»Ð¾ÑÑ Ð´Ð¾Ð±Ð°Ð²Ð¸ÑÑ Ð¼Ð°ÑÐºÑ');
    return { value: id, label };
  }, []);

  const { extraOptions, selectProps, modalProps } = useDictionaryCreator({
    enabled: used,
    kind: 'mark',
    create,
    onChange: props?.onChange,
    onChangeCustom: props?.onChangeCustom,
  });

  const options = useMemo(() => [...extraOptions, ...data], [extraOptions, data]);

  return (
    <>
      <Select
        handleSetSelect={(val) => handleSetSelect && handleSetSelect(val)}
        handleSetState={handleSetState}
        options={options}
        title={'ÐÐ°ÑÐºÐ°'}
        placeholder={'ÐÑÐ±ÐµÑÐ¸ÑÐµ Ð¸Ð· ÑÐ¿Ð¸ÑÐºÐ°'}
        onFocus={onFocus}
        style={style}
        {...props}
        {...selectProps}
      />
      {selectProps && <DictionaryNameModal {...modalProps} />}
    </>
  );
};

export default SelectMarks;
